import { EditPeriodicCheckStateOutDto, EditPeriodicCheckStateInDto } from '../../../types/periodic-check.dto'

export const EDIT_PERIODIC_CHECK_STATE = 'EDIT_PERIODIC_CHECK_STATE'
export const EDIT_PERIODIC_CHECK_STATE_SUCCESS = 'EDIT_PERIODIC_CHECK_STATE_SUCCESS'
export const EDIT_PERIODIC_CHECK_STATE_ERROR = 'EDIT_PERIODIC_CHECK_STATE_ERROR'
export const RESET_EDIT_PERIODIC_CHECK_STATE = 'RESET_EDIT_PERIODIC_CHECK_STATE'

export interface EditPeriodicCheckState {
  type: typeof EDIT_PERIODIC_CHECK_STATE
  payload: EditPeriodicCheckStateOutDto
}

export interface EditPeriodicCheckStateSuccess {
  type: typeof EDIT_PERIODIC_CHECK_STATE_SUCCESS
  payload: EditPeriodicCheckStateInDto<any>
}

export interface EditPeriodicCheckStateError {
  type: typeof EDIT_PERIODIC_CHECK_STATE_ERROR
  payload: string | boolean
}

export interface ResetEditPeriodicCheckState {
  type: typeof RESET_EDIT_PERIODIC_CHECK_STATE
  payload: null
}
export interface State {
  data: EditPeriodicCheckStateInDto<any> | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditPeriodicCheckState | EditPeriodicCheckStateSuccess | EditPeriodicCheckStateError | ResetEditPeriodicCheckState
